// One-shot persistence for the help-nudge card on the dashboard chat FAB.
//
// The dashboard has no chrome.storage; this is the localStorage equivalent of
// the extension's `hasSeenHelpNudge` onboarding milestone. Semantics mirror the
// extension: the flag is written only on the x, so the nudge recurs on each
// dashboard load until the user dismisses it, then never again. The key moved
// from 'oqa_help_nudge_seen' when opening the chat stopped counting
// (Emily, 2026-10-26), so a card retired that way shows once more. Read failures fail-safe to
// "seen" (never show) — a storage error degrades to no nudge, not a nag loop.
// Side-effect-only-via-storage so it unit-tests in isolation (mirrors
// lib/pendingExtensionOpen.ts).

const STORAGE_KEY = 'oqa_help_nudge_dismissed';

export function hasSeenHelpNudge(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    // private-mode / disabled storage — treat as seen so we don't nag forever
    return true;
  }
}

export function markHelpNudgeSeen(): void {
  try {
    localStorage.setItem(STORAGE_KEY, '1');
  } catch {
    // ignore quota / private-mode errors — a failed persist just re-shows next load
  }
}
